// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"az_Xpc","headerTitle":"az_Ypc","backButton":"az_Zpc","backIcon":"az__pc","closeIcon":"az_aqc"};